import NumberCard from './NumberCard';

export default NumberCard;
